import Icon from "@/icons";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Spinner from "@/components/Spinner";
import ErrorBox from "@/components/Error/Box";
import Setuppplications from "./Form/Setup";
import { Application } from "types";
import ApplicationBodyItem from "./ApplicationBody";
import { useState } from "react";
import ViewApplication from "./ViewApplication";
import { TeamApplicationStatusDialog } from "@/components/Dialogs/ChangeApplicationStatus";

export default function ApplicationsChannel() {
    const { teamId, applicationId } = useParams();
    const queryClient = useQueryClient();
    const me = queryClient.getQueryState(["team", teamId, "members", "@me"]) as any;
    const [isEditing, setIsEditing] = useState(false);
    const applicationQuestions = useQuery({
        queryKey: ["team", teamId, "applications", "questions"],
        retry: 1,
        retryDelay: 1000,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const response = await fetch(`__SITE_BASE__/api/v1/teams/${teamId}/applications/questions`);
            return await response.json();
        }
    });

    const getApplicationsStatus = useQuery({
        queryKey: ["team", teamId, "applications", "status"],
        retry: 1,
        retryDelay: 1000,
        enabled: !!applicationQuestions?.data?.questions?.length,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const response = await fetch(`__SITE_BASE__/api/v1/teams/${teamId}/applications/status`);
            return await response.json();
        }
    });

    const getApplications = useQuery({
        queryKey: ["team", teamId, "applications"],
        retry: 1,
        retryDelay: 1000,
        enabled: !!applicationQuestions?.data?.questions?.length,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const response = await fetch(`__SITE_BASE__/api/v1/teams/${teamId}/applications`);
            return await response.json();
        }
    });

    return (
        <div className="flex flex-col w-full border border-brand-dark rounded-lg">
            <div className="flex flex-col w-full rounded-t-lg bg-brand-dark">
                <div className="flex gap-2 p-4 py-4 rounded-lg items-center">
                    <Icon name="applications" size="20" color="#a3a3ac" />
                    <div className="font-semibold text-xl text-white truncate">Applications</div>
                </div>
            </div>
            {!applicationId && applicationQuestions.isFetched && (
                <>
                    {
                        applicationQuestions.isFetched && !applicationQuestions?.data?.questions?.length ? (
                            <Setuppplications questionss={applicationQuestions} />
                        ) : (
                            <div className="flex flex-col gap-4 p-1 sm:p-4">
                                {getApplications.isLoading || getApplicationsStatus.isLoading ? (
                                    [...Array(13)].map((_, index) => (
                                        <Spinner key={index} />
                                    ))
                                ) : getApplications.isError || getApplications.data?.message ? (
                                    <ErrorBox message={(getApplications.error || getApplications.data?.message)?.toString()} />
                                ) : (
                                    <>
                                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0">
                                            <div className="flex items-center gap-2">
                                                <span className="text-white font-semibold text-sm sm:text-lg">Recruitments is</span>
                                                <span className={`font-semibold text-sm sm:text-lg ${getApplicationsStatus?.data?.status ? "text-green-500" : "text-red-500"}`}>
                                                    {getApplicationsStatus?.data?.status ? "open" : "closed"}
                                                </span>
                                                <TeamApplicationStatusDialog teamId={teamId} status={getApplicationsStatus} >
                                                    <div className="cursor-pointer text-gray-300 hover:text-white">
                                                        <Icon name="settings" size="20" />
                                                    </div>
                                                </TeamApplicationStatusDialog>
                                            </div>

                                            <Button className="border-brand-green border hover:bg-brand-green px-4 sm:px-5 py-2 rounded-lg text-white font-semibold text-xs sm:text-sm" onClick={() => setIsEditing(!isEditing)}>
                                                {isEditing ? "Applications" : "Edit Questions"}
                                            </Button>
                                        </div>

                                        {!isEditing && (

                                            <div className="pt-8">
                                                <span className="text-white font-semibold text-lg">
                                                    {getApplications?.data?.applications?.length} Applications
                                                </span>
                                                <div className="bg-brand-dark rounded-lg overflow-x-auto mt-4" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>
                                                    <table className="w-full text-left">
                                                        <thead>
                                                            <tr className="bg-brand-darker text-sm text-gray-400">
                                                                <th className="py-3 px-4 whitespace-nowrap">Applicant</th>
                                                                <th className="py-3 px-4 whitespace-nowrap">Status</th>
                                                                <th className="py-3 px-4 whitespace-nowrap">Submitted At</th>
                                                                <th className="py-3 px-4 whitespace-nowrap">Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {getApplications?.data?.applications?.map((application: Application) => (
                                                                <ApplicationBodyItem key={application.id} item={application} />
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}

                                        {isEditing && (
                                            <Setuppplications questionss={applicationQuestions} />
                                        )}
                                    </>
                                )}
                            </div>
                        )
                    }
                </>
            ) || getApplications.isFetched && (
                <ViewApplication item={getApplications?.data?.applications?.find((application: Application) => application.id === applicationId)} me={me} applications={getApplications} />
            )}

        </div>
    );
}